//#region Imports
import { AuthGuard } from '@app/core/guards/auth.guard';
import { ConfirmHealthInsuranceComponent } from './components/confirm-health-insurance/confirm-health-insurance.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { ContactInformationComponent } from './components/contact-information/contact-information.component';
import { LoginComponent } from './components/login/login.component';
import { MemberResponsePortalComponent } from './page/member-response-portal.component';
import { NgModule } from '@angular/core';
import { PAGES_ROUTES } from './model/constants';
import { PendingChangesGuard } from './guards/pending-changes.guard';
import { RouterModule, Routes } from '@angular/router';
import { SurveyComponent } from './components/survey/survey.component';
//#endregion Imports

const routes: Routes = [
    {
        path: '', component: MemberResponsePortalComponent, children: [
            {
                path: '',
                redirectTo: PAGES_ROUTES.LOGIN,
                pathMatch: 'full'
            },
            {
                path: PAGES_ROUTES.LOGIN,
                component: LoginComponent,
                pathMatch: 'full'
            },
            {
                path: PAGES_ROUTES.SURVEY,
                component: SurveyComponent,
                pathMatch: 'full',
                canDeactivate: [PendingChangesGuard],
                canActivate: [AuthGuard]
            },
            {
                path: PAGES_ROUTES.CONTACT_INFORMATION,
                component: ContactInformationComponent,
                pathMatch: 'full',
                canDeactivate: [PendingChangesGuard],
                canActivate: [AuthGuard]
            },
            {
                path: PAGES_ROUTES.CONFIRM_HEALTH_INSURANCE,
                component: ConfirmHealthInsuranceComponent,
                pathMatch: 'full',
                canDeactivate: [PendingChangesGuard],
                canActivate: [AuthGuard]
            },
            {
                path: PAGES_ROUTES.CONFIRMATION,
                component: ConfirmationComponent,
                pathMatch: 'full',
                canDeactivate: [PendingChangesGuard],
                canActivate: [AuthGuard]
            },
            {
                path: '**',
                redirectTo: 'login',
                pathMatch: 'full'
            },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MemberResponsePortalRouting { }
